module.exports = __webpack_public_path__ + "static/banner-one-shape1-b8010748af9757cf2d1d6ac6eec3a1f3.png";